
import React from 'react';
import { api, soloMuevenCaja } from './api';
import { connect } from 'react-redux';
import { message, Modal, Form, Input, Row, Col, Select } from 'antd';
import queryString from 'query-string';

const FormItem = Form.Item;
const Option = Select.Option;

class Nuevo extends React.Component {
    state = {
        confirmLoading: false,
        formasPago: [],
    }

    async componentDidMount() {
        this.fetchFormasPago();
    }

    fetchFormasPago = async () => {
        try {
            const response = await api.mpago.getAll(queryString.stringify({
                pagina: 1,
                limite: 500,
            }));
            if (response.status === "success") {
                this.setState({ formasPago: soloMuevenCaja(response.data.formasPago) });
            } else {
                this.setState({ formasPago: [] });
                message.error(response.message, 5);
            }
        } catch (e) {
            message.error(e.toString(), 7);
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    this.setState({ confirmLoading: true });
                    const data = {
                        idusuario: this.props.idusuario || (this.props.user ? this.props.user.codigoempl : null),
                        tipo: values.tipo,
                        concepto: values.concepto,
                        importe: parseFloat(values.importe),
                    };
                    if (values.codforpago !== undefined && values.codforpago !== null) {
                        data.codforpago = values.codforpago;
                    }
                    const response = await api.caja.movimiento(data);
                    if (response.status === "success") {
                        message.success(response.message || "Movimiento registrado");
                        this.props.closeModal(response.saldo);
                    } else {
                        message.error(response.message, 7);
                    }
                } catch (e) {
                    message.error(e.toString(), 7);
                } finally {
                    this.setState({ confirmLoading: false });
                }
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { formasPago } = this.state;

        return (
            <Modal
                visible={true}
                confirmLoading={this.state.confirmLoading}
                onOk={this.handleSubmit}
                onCancel={() => this.props.closeModal()}
                cancelText="Cancelar"
                okText="Aceptar"
                width={600}
            >
                <section className="form-v1-container col-md-12">
                    <h4 style={{ marginBottom: 15 }}>Nuevo movimiento</h4>
                    <Form style={{ marginTop: 10 }}>
                        <Row gutter={8}>
                            <Col span={24}>
                                <FormItem label="Tipo" {...{
                                    labelCol: { sm: { span: 6 } },
                                    wrapperCol: { sm: { span: 16 } },
                                }}>
                                    {getFieldDecorator('tipo', {
                                        initialValue: undefined,
                                        rules: [{ required: true, message: "Este campo es requerido" }],
                                    })(
                                        <Select style={{ width: '100%' }} placeholder="Seleccionar">
                                            <Option value="I">Ingreso</Option>
                                            <Option value="E">Egreso</Option>
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col span={24}>
                                <FormItem label="Concepto" {...{
                                    labelCol: { sm: { span: 6 } },
                                    wrapperCol: { sm: { span: 16 } },
                                }}>
                                    {getFieldDecorator('concepto', {
                                        initialValue: '',
                                        rules: [{ required: true, message: "Este campo es requerido" }],
                                    })(
                                        <Input placeholder="Concepto" />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col span={24}>
                                <FormItem label="Importe" {...{
                                    labelCol: { sm: { span: 6 } },
                                    wrapperCol: { sm: { span: 16 } },
                                }}>
                                    {getFieldDecorator('importe', {
                                        initialValue: '',
                                        rules: [
                                            { required: true, message: "Este campo es requerido" },
                                            {
                                                validator: (rule, value, callback) => {
                                                    if (value === '' || value === undefined || parseFloat(value) > 0) {
                                                        callback();
                                                    } else {
                                                        callback("El importe debe ser mayor a cero");
                                                    }
                                                }
                                            },
                                        ],
                                    })(
                                        <Input type="number" min={0} placeholder="Importe" />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col span={24}>
                                <FormItem label="Forma de pago" {...{
                                    labelCol: { sm: { span: 6 } },
                                    wrapperCol: { sm: { span: 16 } },
                                }}>
                                    {getFieldDecorator('codforpago', {
                                        initialValue: undefined,
                                    })(
                                        <Select
                                            style={{ width: '100%' }}
                                            placeholder="Efectivo (por defecto)"
                                            optionFilterProp="children"
                                            showSearch
                                            allowClear
                                            filterOption={(input, option) =>
                                                String(option.props.children || "").toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {formasPago.map((data, index) => (
                                                <Option value={data.codigofpag} key={index}>{data.descrifpag}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                </section>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

const WrappedNuevo = Form.create()(Nuevo);

export default connect(mapStateToProps)(WrappedNuevo);
